// Hamburger-menu voor mobile viewports (<md). Slide-in drawer met nav-links.

import { useState } from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface NavItem {
  to: string;
  labelKey: string;
  default: string;
  exact?: boolean;
}

export function MobileNav({ items, userEmail, role }: { items: NavItem[]; userEmail: string; role: string }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="md:hidden p-2 rounded-lg hover:bg-neutral-100 text-neutral-700"
        aria-label={t("nav.openMenu", "Menu openen")}
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="3" y1="6" x2="21" y2="6" />
          <line x1="3" y1="12" x2="21" y2="12" />
          <line x1="3" y1="18" x2="21" y2="18" />
        </svg>
      </button>

      {open && (
        <div
          className="md:hidden fixed inset-0 z-40 bg-black/50"
          onClick={() => setOpen(false)}
          role="presentation"
        >
          <aside
            className="absolute left-0 top-0 bottom-0 w-64 bg-white shadow-xl flex flex-col"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="px-4 py-5 border-b border-neutral-200 flex items-center justify-between">
              <div>
                <h1 className="text-lg font-semibold">Balans Buddy</h1>
                <p className="text-xs text-neutral-500 mt-0.5">{role}</p>
              </div>
              <button
                onClick={() => setOpen(false)}
                className="p-1 rounded hover:bg-neutral-100"
                aria-label={t("nav.closeMenu", "Menu sluiten")}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
            </div>
            <nav className="flex-1 px-2 py-4 space-y-1 overflow-y-auto">
              {items.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.exact}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) =>
                    `block px-3 py-2 text-sm rounded-lg transition-colors ${
                      isActive
                        ? "bg-brand-50 text-brand-700 font-medium"
                        : "text-neutral-700 hover:bg-neutral-100"
                    }`
                  }
                >
                  {t(item.labelKey, item.default)}
                </NavLink>
              ))}
            </nav>
            <div className="px-3 py-3 border-t border-neutral-200">
              <p className="text-xs text-neutral-500 truncate">{userEmail}</p>
            </div>
          </aside>
        </div>
      )}
    </>
  );
}
